import { Badge } from '@mantine/core';
import { SplitPlanStatus } from '@/models/split-plan';

export type ScheduleState = SplitPlanStatus | 'none';

const STATE_META: Record<ScheduleState, { color: string; label: string }> = {
  none: { color: 'gray', label: 'No split' },
  draft: { color: 'gray', label: 'Draft' },
  proposed: { color: 'blue', label: 'Awaiting BizDev' },
  returned: { color: 'orange', label: 'Returned to SR' },
  approved: { color: 'teal', label: 'Approved' },
  committed: { color: 'green', label: 'Committed' },
  cancelled: { color: 'gray', label: 'Cancelled' },
};

export function splitStateMeta(state: ScheduleState) {
  return STATE_META[state];
}

export default function ScheduleStateBadge({
  state,
  size = 'sm',
}: {
  state: ScheduleState;
  size?: string;
}) {
  const meta = STATE_META[state] ?? STATE_META.none;
  return (
    <Badge size={size} variant="light" color={meta.color}>
      {meta.label}
    </Badge>
  );
}
